import React, { useEffect, useState } from 'react';
import { locales } from '../../../translations/locales';
import nbJoursDansLeMois from '../../../controllers/nbJoursMois';
import Month from '../../moment/Month';
import { NotificationManager } from 'react-notifications';
import { _$, _setText } from '../../../controllers/dom';
import SelectHours from './planning/SelectHours';
import { Tooltip } from 'react-tooltip';
import checkDatePlanning from '../../../controllers/checkDatePlanning';

const Planning = (props) => {
    const { data, ModuleRP, locale, theme, assignment } = props;

    const [editPlanning, setEditPlanning] = useState(false);
    const [player, setPlayer] = useState(data.listPlayers.find((e) => e.id === ModuleRP.userId) || null);
    const [waitForUpdate, setWaitForUpdate] = useState(false);
    const [planningStatus, setPlanningStatus] = useState(0);

    const updatePlanning = () => {
        if (!editPlanning) return NotificationManager.error(locales[locale].planning.noEntry);
        const planningStatus = _$('planningStatus').value;
        const startPlanningTime = _$('startPlanningTime').value;
        const endPlanningTime = _$('endPlanningTime').value;
        setWaitForUpdate(true);
        setPlanningStatus('inherit');
        ModuleRP.updatePlanning(editPlanning, assignment, planningStatus, startPlanningTime, endPlanningTime);
    };

    const deletePlanning = (id) => {
        if (!editPlanning) return NotificationManager.error(locales[locale].planning.noEntry);
        setPlanningStatus('inherit');
        setWaitForUpdate(true);
        ModuleRP.deletePlanning(id, assignment);
    };

    useEffect(() => {
        if (!player && data.listPlayers && data.listPlayers.length > 0) {
            setPlayer(data.listPlayers.find((e) => e.id === ModuleRP.userId));
            player.schedules.sort((a, b) => a.day - b.day);
        } else if (player && waitForUpdate) {
            setPlayer(data.listPlayers.find((e) => e.id === ModuleRP.userId));
            player.schedules.sort((a, b) => a.day - b.day);
        }
        if (player && player.schedules) {
            player.schedules.sort((a, b) => a.day - b.day);
            const status = player.schedules.find(
                (e) => e.day === new Date().getDate() &&
                    e.assignment === assignment &&
                    e.month === new Date().getMonth() + 1 &&
                    checkDatePlanning(e.startTime, '>') &&
                    checkDatePlanning(e.endTime, '<'));
            if (status) {
                setPlanningStatus(ModuleRP.planningStatus.find((e) => e.id === status.status)?.color);
            }
        }
        if (waitForUpdate) {
            if (waitForUpdate && _$('btn-updatePlanning')) {
                _setText('btn-updatePlanning', locales[locale].config.update);
                _$('btn-updatePlanning').disabled = false;
                setWaitForUpdate(false);
            }
        }
    }, [data, assignment, locale, player.schedules]);

    return (
        <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
            <div className="card container p-0 gameInformations mt-5">
                <h5 className="card-header bg-primary">
                    {locales[locale].assignments.planning}
                </h5>
                <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <h6><Month locale={locale} /></h6>
                    {
                        [...Array(nbJoursDansLeMois())].map((_, index) => {
                            const date = new Date();
                            date.setDate(index + 1);
                            const editable = date < new Date();
                            const actualDay = new Date().getDate() === date.getDate();
                            return (
                                <div
                                    key={index}
                                    className={
                                        `d-inline-block m-1 border border-solid border-${theme === 'DARK' ? 'light' : 'dark'} 
                                        p-1 ${editable ? 'bg-secondary' : 'cursor-pointer'}`
                                    }
                                    style={
                                        {
                                            minWidth: '30px',
                                            backgroundColor: `${actualDay && planningStatus ? planningStatus : 'inherit'}`,
                                        }
                                    }
                                    onClick={() => {
                                        if (editable) {
                                            return;
                                        }
                                        setEditPlanning(date.getDate());
                                    }}
                                >
                                    <div className="text-center">
                                        {index + 1}
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
            {
                editPlanning ? (
                    <div className="card container p-0 gameInformations mt-5">
                        <h5 className="card-header bg-primary">
                            {locales[locale].assignments.planning} {editPlanning}
                        </h5>
                        <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                            <div className="d-flex justify-content-around mb-2">
                                {
                                    (() => {
                                        const schedules = player.schedules.filter(
                                            (e) =>
                                                e.day === editPlanning &&
                                                e.assignment === assignment &&
                                                e.month === new Date().getMonth() + 1);
                                        return (
                                            <ul>
                                                <h6>{locales[locale].planning.planningStatus}</h6>
                                                {
                                                    schedules.length > 0 ? (
                                                        schedules.map((schedule, index) => (
                                                            <li
                                                                key={schedule.id}
                                                                style={
                                                                    { color: ModuleRP.planningStatus.find((e) => e.id === schedule.status)?.color || 'inherit' }
                                                                }
                                                            >
                                                                {locales[locale].planning[schedule.status]} {schedule.startTime} - {schedule.endTime}
                                                                <button
                                                                    className={`badge badge-danger cursor-pointer mb-1 ml-1`}
                                                                    onClick={() => deletePlanning(schedule.id)}
                                                                    data-tip data-tooltip-id={`delete-${index}`}
                                                                >
                                                                    x
                                                                    <Tooltip id={`delete-${index}`} place='top' effect='solid' className='text-center'>
                                                                        {locales[locale].planning.deletePlanning}
                                                                    </Tooltip>
                                                                </button>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <li key="noEntry">
                                                            {locales[locale].planning.noEntry}
                                                        </li>
                                                    )
                                                }
                                            </ul>
                                        );
                                    })()
                                }
                            </div>
                            <div className="d-flex justify-content-around">
                                <div className='form-group'>
                                    <label htmlFor='planningStatus'>{locales[locale].planning.planningStatus}</label>
                                    <select
                                        id='planningStatus'
                                        className={`form-control form-control-sm ${theme === 'DARK' ? 'bg-dark text-light' : 'bg-light text-dark'}`}
                                    >
                                        {ModuleRP.planningStatus.map((planningStatus) => (
                                            <option
                                                key={planningStatus.id}
                                                value={planningStatus.id}
                                            >
                                                {locales[locale].planning[planningStatus.id]}
                                            </option>
                                        ))
                                        }
                                    </select>
                                </div>
                                <SelectHours theme={theme} locale={locale} id='startPlanningTime' editPlanning={editPlanning} />
                                <SelectHours theme={theme} locale={locale} id='endPlanningTime' editPlanning={editPlanning} />
                            </div>
                            <button
                                className={`btn btn-success float-right`}
                                id='btn-updatePlanning'
                                onClick={updatePlanning}
                            >
                                {locales[locale].config.update}
                            </button>
                        </div>
                    </div>
                ) : ''
            }
        </div>
    );
};

export default Planning;
